export const styles = theme => ({
  avatar: {
    height: 30,
    width: 30,
    fontSize: 15
  },
  root: {
    textAlign: 'left'
  },
  title: {
    marginLeft: 18
  },
  itemTitle: {
    marginLeft: 5
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/styles/components/ColorLegend.js